import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
// components

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            ...item,
            role: item?.role?.id || "",
          }}
          onSubmit={async (values, { setSubmitting }) => {
            console.log("props: ", props);

            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "password",
              "permissions",
              "updatedAt",
              "uuid",
              "createdAt",
              "isEmailVerified",
              "isPhoneVerified",
            ]);

            await props.submit(clean, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="translations.fa.lastName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی(en)"
                    label="نام خانوادگی(en) :"
                    name="translations.en.lastName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام کاربری"
                    label="نام کاربری :"
                    name="userName"
                    component={TextField}
                    //   validate={isUserName}
                  />
                  <Field
                    placeholder="شماره تماس"
                    label="شماره تماس: "
                    name="phoneNumber"
                    component={TextField}
                    validate={isUserName}
                  />
                  {/* <Field
                    placeholder="آدرس و شماره تلفن کافه"
                    label="ادرس و شماره تلفن :"
                    name="address"
                    component={TextArea}
                  />
                  <Field
                    placeholder="آدرس و شماره تلفن کافه(en)"
                    label="ادرس و شماره تلفن(en) :"
                    name="_en*address*text"
                    component={TextArea}
                  /> */}
                  <div className="user-datepicker">
                    <Field
                      label="تاریخ تولد :"
                      name="birthday"
                      component={PersianDataPicker}
                    />
                  </div>
                  <Field
                    placeholder="ایمیل"
                    label="ایمیل: "
                    name="email"
                    component={TextField}
                    // validate={isUserName}
                  />
                  {/* <div>
                    <Field
                      placeholder="کشور"
                      label="کشور :"
                      name="country_id"
                      component={Select}
                      options={core.countries || []}
                    />
                  </div> */}

                  <Field
                    label="نقش ها :"
                    name="role"
                    valueOnly
                    component={Select}
                    options={core.roles}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
